import { useNavigate } from "react-router-dom";
import SectionLabel from "@/components/base/SectionLabel";
import { pricingData } from "@/mocks/pricingData";

export default function MonthlySupportSection() {
  const navigate = useNavigate();

  return (
    <section id="monthly-support" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-8 md:mb-10 reveal">
          <SectionLabel label={pricingData.monthlySupport.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {pricingData.monthlySupport.title}
          </h2>
        </div>

        {/* Note about pricing difference */}
        <div className="reveal max-w-3xl mx-auto mb-8 md:mb-10">
          <div className="flex items-start gap-2.5 px-4 py-3 rounded-md bg-background-50 border border-background-200/70">
            <i className="ri-information-line text-primary-500 mt-0.5 flex-shrink-0" />
            <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
              {pricingData.monthlySupport.note}
            </p>
          </div>
        </div>

        <div className="reveal grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          {pricingData.monthlySupport.plans.map((plan) => (
            <div
              key={plan.name}
              className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8 flex flex-col"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-100 flex items-center justify-center mb-5">
                <i className={`${plan.icon} text-xl md:text-2xl text-primary-600`} />
              </div>

              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-1">
                {plan.name}
              </h3>

              <p className="text-xs md:text-sm text-foreground-600 mb-4">
                {plan.target}
              </p>

              <div className="bg-primary-50 rounded-lg p-4 md:p-5 mb-5 border border-primary-200/50">
                <div className="flex items-baseline gap-1 mb-2">
                  <span className="text-lg md:text-xl font-bold text-primary-700 font-heading">
                    {plan.pricing}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {plan.pricingDetail}
                </p>
              </div>

              <ul className="space-y-2.5 mb-6 flex-1">
                {plan.features.map((feature, i) => (
                  <li key={i} className="flex items-start gap-2.5">
                    <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0" />
                    <span className="text-sm md:text-base text-foreground-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <a
                href={plan.linkHref}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(plan.linkHref);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className="inline-flex items-center gap-1.5 text-sm md:text-base font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer mt-auto"
              >
                {plan.linkLabel}
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}